import RealAssetTreeDropdown from "../realAsset/realAssetTreeDropdown";
import RealAssetDeploymentTreeDropdown from "../realAsset/realAssetDeploymentTreeDropdown";

const RealAssetFiltersGroup = ({
    rawValues,
    handleRealAssetSelection,
    handleDeploymentSelection,
    showRealAssetFilter = true,
    showDeploymentFilter = true
}: {
    rawValues: any;
    handleRealAssetSelection: (option: any) => void;
    handleDeploymentSelection: (option: any) => void;
    showRealAssetFilter?: boolean;
    showDeploymentFilter?: boolean;
}) => {
    if (!showRealAssetFilter && !showDeploymentFilter) return null;

    return (
        <div className="flex flex-col items-start">
            <p className="self-start text-lg text-blue-200">Real Asset</p>
            <div className="mt-1 flex flex-wrap items-center gap-4">
                {showRealAssetFilter && (
                    <div className="z-40 w-[14rem] shrink-0">
                        <RealAssetTreeDropdown
                            selectedIds={rawValues.realAssetPublicIds}
                            onOptionToggle={handleRealAssetSelection}
                            initiallyExpanded
                            labelClassName="w-[14rem] shrink-0"
                            dropdownClassName="min-w-[18rem]"
                        />
                    </div>
                )}
                {showDeploymentFilter && (
                    <div className="z-40 w-[14rem] shrink-0">
                        <RealAssetDeploymentTreeDropdown
                            selectedIds={rawValues.realAssetDeploymentPublicIds}
                            onOptionToggle={handleDeploymentSelection}
                            labelClassName="w-[14rem] shrink-0"
                            dropdownClassName="min-w-[22rem]"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default RealAssetFiltersGroup;
